import { ICollectionPoint, InvitationStatus } from "../types/collectionPoint";
import { IContainer } from "../types/container";
import { getSkeletonMockedArray } from "../utils/tables/getSkeletonMockedArray";

export const defaultContainer: IContainer = {
  barCode: "",
  rfid: "",
  wasteType: 0,
  containerId: 0,
  locationId: 0,
  totalWaste: 0,
  totalDumpings: 0,
  containerType: 0,
  disableTime: null,
  id: 0,
  isMocked: false,
  noteType: null,
};

export const defaultContainers: IContainer[] = getSkeletonMockedArray(defaultContainer, 50, 0);

export const defaultCollectionPoint: ICollectionPoint = {
  containers: defaultContainers,
  degreeOfSeparation: 0,
  householdMembersCount: 0,
  name: "-",
  wastePerHouseholdMember: 0,
  locationId: 0,
  administrationId: 0,
  address: "-",
  isPO: false,
  invitationToken: null,
  invitationStatus: InvitationStatus.NotInvited,
  isPaid: false,
  year: new Date().getFullYear(),
  disableTime: null,
  enableTime: null,
  billing: null,
  billingStatus: null,
  paymentSchedule: null,
  payments: null,
  refunds: null,
};
